module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#online-news",
      toString: function () {
        return this.url;
      }
    }